const isChildNode = (target, parent) => {
    if (parent == null) {
        return false;
    }

    const parentNode = target.parentNode;
    if (parentNode == null) {
        return false;
    }
    if (parentNode === parent) {
        return true;
    }
    return isChildNode(parentNode, parent);
};
exports.isChildNode = isChildNode;

const isParentNode = (target, child) => {
    return isChildNode(child, target);
};
exports.isParentNode = isParentNode;
